import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { AuditCategoryCountType } from '@/types/auditLogTypes';

export const getAuditCatalogApi = (): Promise<ApiResponseType<{ categories: AuditCategoryCountType[] }>> => {
  return authApiService.GET('/audit-log/catalog/');
};
